// extracted by mini-css-extract-plugin
module.exports = {"ActionDropdown":"_2-lNZLgQ","promptModal":"_1ouOJg4a","promptContent":"_3oAexFiD","promptButtons":"_21BwElBI","promptTitle":"_2f2o5TGO","promptSubtitle":"_1K7nQY6R","confirm":"_3xCOyzXk"};
    if(module.hot) {
      // 1746735820689
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  